export default __webpack_public_path__ + "./fonts/icon_yes.0b1ff17d53ca1127387cb33d2371991b.svg";